<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-stepper v-model="stepNumber" vertical>
      <v-stepper-step step="1" :complete="stepNumber > 1">
        Public Information
      </v-stepper-step>
      <v-stepper-content step="1">
        <v-form ref="formPublicInfo" lazy-validation>
          <v-card
            elevation="3"
            style="border: 1px solid #e0e0e0"
            class="mb-6 pt-3 pb-3"
          >
            <v-row>
              <v-col cols="12" lg="6" class="pb-0">
                <v-text-field
                  :rules="[rules.required, rules.maxvalue]"
                  v-model="bookName"
                  class="mx-3"
                  label="Book Name"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="bookLink"
                  class="mx-3"
                  label="Book Drive Link"
                  outlined
                  dense
                ></v-text-field>
                <v-textarea
                  v-model="dsecription"
                  class="mx-3"
                  label="Book Dsecription"
                  outlined
                  rows="4"
                  height="106"
                  dense
                ></v-textarea>
                <v-switch
                   class="mx-3"
                  v-model="isdownloadable"
                  flat
                  label="Is downloadable"
                ></v-switch>
              </v-col>
              <v-col cols="12" lg="6" class="pb-0">
                <v-autocomplete
                  :rules="[rules.required]"
                  v-model="langID"
                  class="mx-3"
                  :items="listLang"
                  dense
                  label="Lang"
                  outlined
                  item-text="langname"
                  item-value="langid"
                ></v-autocomplete>

                <v-autocomplete
                  :rules="[rules.requiredArray]"
                  v-model="selectedCategories"
                  :items="selectedCategories"
                  outlined
                  dense
                  :readonly="true"
                  chips
                  class="mx-3"
                  small-chips
                  label="Categories"
                  multiple
                  item-text="categoryname"
                  item-value="categoryid"
                  @focus="dialogCategoryTree = true"
                ></v-autocomplete>

                <v-autocomplete
                  :rules="[rules.required]"
                  :search-input.sync="authorNameSearch"
                  v-model="authorID"
                  class="mx-3"
                  :items="listAuthors"
                  dense
                  label="Author Name"
                  outlined
                  item-text="authorname"
                  item-value="authorid"
                  @keyup="searchAuthor()"
                  @keyup.ctrl.enter="addDialogAuthor = true"
                ></v-autocomplete>

                <v-file-input
                  class="mx-3"
                  label="Book Cover"
                  outlined
                  prepend-icon="mdi-camera"
                  dense
                  @change="selectCover"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-card>
          <v-btn color="primary" @click="stepOne()" :loading="loadingStepOne">
            Continue
          </v-btn>
        </v-form>
      </v-stepper-content>
      <v-stepper-step step="2" :complete="stepNumber > 2">
        Version Infornation
      </v-stepper-step>
      <v-stepper-content  step="2">
        <v-form ref="formVersion" lazy-validation>
          <v-card
            elevation="3"
            style="border: 1px solid #e0e0e0"
            class="mb-6 pt-3 pb-3"
          >
            <v-row>
              <v-col cols="12" lg="6" class="pb-0">
                <v-autocomplete
                  :rules="[rules.required]"
                  :search-input.sync="publisherNameSearch"
                  v-model="publisherID"
                  class="mx-3"
                  :items="listPublishers"
                  dense
                  label="Publisher Name"
                  outlined
                  item-text="publishername"
                  item-value="publisherid"
                  @keyup="searchPublishers()"
                  @keyup.ctrl.enter="addDialogPublisher = true"
                ></v-autocomplete>
                <v-text-field
                  :rules="[rules.required, rules.onlynumber]"
                  v-model="publisherYear"
                  class="mx-3"
                  label="Published Year"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" class="pb-0">
                <v-file-input
                  :rules="[rules.required]"
                  class="mx-3"
                  label="Book File"
                  @change="selectBookFile"
                  outlined
                  dense
                ></v-file-input>
                <v-row>
                  <v-col cols="12" lg="6" class="pl-6">
                    <v-switch
                      class="mt-0"
                      v-model="status"
                      label="Status"
                      color="primary"
                      hide-details
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-switch
                      class="mt-0"
                      v-model="defaultbook"
                      label="Default Book"
                      color="primary"
                      hide-details
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
        <v-btn color="primary" @click="stepTwo()" :loading="loadingSteptow">
          Continue
        </v-btn>
      </v-stepper-content>
      <v-stepper-step step="3" :complete="stepNumber > 3"> Meta Data Information </v-stepper-step>
      <v-stepper-content step="3" >
        <v-form ref="formMetaValue" lazy-validation>
          <v-card
            elevation="3"
            style="border: 1px solid #e0e0e0"
            class="mb-6 pt-3 pb-3"
          >
            <v-row>
              <v-col cols="12">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Meta Name</th>
                        <th class="text-left">Meta Value</th>
                        <th class="text-left">Remover</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in metaData" :key="index">
                        <td>
                          <v-text-field
                            class="mt-4"
                            label="Meta Value"
                            :rules="[rules.required]"
                            name="login"
                            v-model="item.meta_name"
                            outlined
                            dense
                          >
                          </v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            class="mt-4"
                            label="Meta Value"
                            :rules="[rules.required]"
                            name="login"
                            v-model="item.meta_value"
                            outlined
                            dense
                          >
                          </v-text-field>
                        </td>
                        <td class="pb-4">
                          <span @click="removerMeta(index)"
                            ><i class="status fa fa-times-circle red--text"></i
                          ></span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-btn
                  color="#1B5E20"
                  class="white--text float-right mr-4 mt-4"
                  @click="newMeta"
                >
                  New Meta
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
        <v-btn color="primary" @click="stepThree" :loading="loadingStepThree">
          Upload
        </v-btn>
      </v-stepper-content>

      <v-stepper-step step="4" :complete="stepNumber > 4">
        Publication status
      </v-stepper-step>
      <v-stepper-content step="4">
        <v-form ref="form" lazy-validation>
          <v-card
            elevation="3"
            style="border: 1px solid #e0e0e0"
            class="mb-6 pt-3 pb-3"
          >
            <v-row>
              <v-col cols="12" lg="6" class="pb-0">
                <p class="ml-3">The book has been successfully uploaded , <br>Do you want to publish the book ?</p>
                <v-btn
                  class="ml-3"
                  color="primary"
                  @click="PublishBook()"
                  :loading="loadingStepOne"
                >
                  Yes
                </v-btn>
                <v-btn
                  class="ml-3"
                  color="warning"
                  @click="goToListBook()"
                  :loading="loadingStepOne"
                >
                  No, I Don't Want
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-stepper-content>
    </v-stepper>

    <SelectTreeCategory
      :dialogCategoryTree="dialogCategoryTree"
      v-on:closeCatDialog="closeCategory($event)"
      v-on:closeCatDialogWithCategories="
        closeCatDialogWithCategoriesMethod($event)
      "
    />
    <AddAuthor
      :addDialog="addDialogAuthor"
      v-on:DialogClose="DialogClose($event)"
    />
    <AddPublisher
      :addDialog="addDialogPublisher"
      v-on:DialogClose="DialogClose($event)"
    />
  </v-container>
</template>

<script src="https://unpkg.com/axios/dist/axios.min.js"></script>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import SelectTreeCategory from "@/components/Category/SelectTreeCategory";
import AddAuthor from "@/components/Authors/AddAuthor";
import AddPublisher from "@/components/Publishers/AddPublisher";

export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        requiredArray: (value) => value != "" || "Field required.",
        maxvalue: (value) =>
          value.length <= 128 || "Maximum length is 128 characters",
        onlynumber: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0) || "Value Only Number",
      },
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Books",
          disabled: false,
          to: "/books",
        },
        {
          text: "Add Book",
          disabled: true,
        },
      ],

      loadingStepOne: false,
      loadingSteptow: false,
      loadingStepThree: false,
      stepNumber: 1,
      addDialogAuthor: false,
      addDialogPublisher: false,
      listLang: [],
      listAuthors: [],
      listPublishers: [],
      dialogCategoryTree: false,
      authorNameSearch: "",
      publisherNameSearch: "",
      //----------------------
      bookName: "",
      langID: 1,
      bookLink: "",
      dsecription: "",
      selectedCategories: [],
      authorID: "",
      publisherID: "",
      coverBook: "",
      isdownloadable : true ,
      // ------
      BookID: "",
      VersionID: "66",
      metaData: [],
      publisherYear: "",
      status: 1,
      defaultbook: 1,
      fileBook: "",
      // ------
    };
  },

  components: {
    Breadcrumbs,
    SelectTreeCategory,
    AddAuthor,
    AddPublisher,
  },

  mounted() {
    this.getAllLang();
    this.getAllAuthors();
    this.getAllPublishers();
  },

  methods: {
    selectCover(file) {
      this.coverBook = file;
    },
    selectBookFile(file) {
      this.fileBook = file;
    },
    stepOne() {
      if (this.$refs.formPublicInfo.validate() != false) {
        this.loadingStepOne = true;
        if(this.isdownloadable == true){
          this.isdownloadable =  1 
        }
        //else{
        //    this.isdownloadable =  0
        // }
        const fd = new FormData();
        fd.append("bookname", this.bookName);
        fd.append("langid", this.langID);
        fd.append("bookdsecription", this.dsecription);
        fd.append("booklink", this.bookLink);
        fd.append("isdownloadable", this.isdownloadable);
        for (let index = 0; index < this.selectedCategories.length; index++) {
          fd.append(
            "category[]",
            JSON.stringify(this.selectedCategories[index]["categoryid"])
          );
        }
        fd.append("author[]", JSON.stringify(this.authorID));
        if (this.coverBook != "") {
          fd.append("cover", this.coverBook);
        }
        let DataForm = {
          Param: fd,
          API: "/admin/book",
        };
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then((responce) => {
            this.loadingStepOne = false;
            this.BookID = responce.data.data.bookid;
            this.stepNumber++;
          })
          .catch((error) => {
            let errorObj = error.data.data;
            this.loadingStepOne = false;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    stepTwo() {
      if (this.$refs.formVersion.validate() != false) {
        this.loadingSteptow = true;
        const fd = new FormData();
        if (this.status == true) {
          this.status = 1;
        } else {
          this.status = 0;
        }
        if (this.defaultbook == true) {
          this.defaultbook = 1;
        } else {
          this.defaultbook = 0;
        }

        fd.append("file", this.fileBook);
        fd.append("status", this.status);
        fd.append("isdefault", this.defaultbook);
        fd.append("publisher[publisherid]", this.publisherID);
        fd.append("publisher[year]", this.publisherYear);

        let DataForm = {
          Param: fd,
          API: "/admin/book/" + this.BookID + "/version",
        };
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then((responce) => {
            this.VersionID = responce.data.data.versionid;
            this.$store
              .dispatch(
                "GetFromAPI",
                "/admin/book/" +
                  this.BookID +
                  "/version/" +
                  this.VersionID +
                  "/metainfo/generate"
              )
              .then((responseMeta) => {
                this.loadingSteptow = false;
                this.metaData = responseMeta["data"]["data"];
                this.stepNumber++;
              });
          })
          .catch((error) => {
            this.loadingSteptow = false;
            let errorObj = error.data.data;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    stepThree() {
      if (this.$refs.formMetaValue.validate() != false) {
        this.loadingStepThree = true;
        let DataForm = {
          Param: {
            metainfo: this.metaData,
          },
          API:
            "/admin/book/" +
            this.BookID +
            "/version/" +
            this.VersionID +
            "/metainfo",
        };
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then(() => {
            this.stepNumber++;
            this.loadingStepThree = false;
            this.$store.dispatch("PushSuccessMsg", " Added Book Success");
          })
          .catch((error) => {
            this.loadingStepThree = false;
            let errorObj = error.data.data;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    PublishBook() {
      let DataForm = {
        API: "/admin/book/"+this.BookID+"/version/" + this.VersionID + "/publish",
      };
      this.$store
        .dispatch("PutToAPI", DataForm)
        .then((response) => {
          this.$store.dispatch("PushSuccessMsg", response.data.message);
          this.loadingAdd = false;
          this.$router.push({ name: "Books" }).catch(() => {});
        })
        .catch(() => {
          this.loadingAdd = false;
          this.$store.dispatch("PushErrorMsg", "Validation Error");
        });
    },
    goToListBook(){
      this.$router.push({ name: "Books" }).catch(() => {});
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/admin/lang").then((response) => {
        this.listLang = response["data"]["data"];
      });
    },
    getAllAuthors() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/author?per_page=20&filter[authorname]=" +
            this.authorNameSearch
        )
        .then((response) => {
          this.listAuthors = response["data"]["data"];
        });
    },
    getAllPublishers() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/publisher?per_page=20&filter[publishername]=" +
            this.publisherNameSearch
        )
        .then((response) => {
          this.listPublishers = response["data"]["data"];
        });
    },
    closeCatDialogWithCategoriesMethod(vals) {
      this.dialogCategoryTree = false;
      this.selectedCategories = vals;
    },
    closeCategory() {
      this.dialogCategoryTree = false;
    },
    searchAuthor() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllAuthors();
      }
    },
    searchPublishers() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllPublishers();
      }
    },
    DialogClose() {
      this.addDialogAuthor = false;
      this.addDialogPublisher = false;
    },
    removerMeta(index) {
      this.metaData.splice(index, 1);
    },
    newMeta() {
      this.metaData.push({ meta_name: "", meta_value: "" });
    },
  },
};
</script>